import "@hotwired/turbo-rails"
import "trix"
import "@rails/actiontext"
import "../controllers"

console.log('Vite ⚡️ Rails')
